import { Component, Input } from '@angular/core';
import { PropertiesSettings } from "../../../../core/configuration/properties-settings";
import { BeneficiarioPagamento } from '../../../models/beneficiario-pagamento';
import { Pagamento } from '../../../models/pagamento';

@Component({
    selector: '[pagamento_entity_view]',
  templateUrl: 'pagamento-entity-view.component.html',
})

export class PagamentoEntityViewComponent {
  readonly PROPERTIES_SETTINGS = PropertiesSettings;
  @Input()
  element: Pagamento;
  @Input()
  beneficiarioPagamento: BeneficiarioPagamento;
}
